export function mergeWithDefaults<T>(raw: any, defaults: T): T {
  if (Array.isArray(defaults)) {
    return Array.isArray(raw) ? [...raw] : [...defaults];
  }

  if (typeof defaults === 'object' && defaults !== null) {
    const result: any = {};
    for (const key in defaults) {
      result[key] = mergeWithDefaults(raw?.[key], defaults[key]);
    }
    return result;
  }

  return raw !== undefined ? raw : defaults;
}
